import {
  INVOICE_NOTE_ADD_REQUEST,
  INVOICE_NOTE_ADDED,
  INVOICE_NOTE_DELETE_REQUEST,
  INVOICE_NOTE_DELETED,
  INVOICE_NOTES_ERROR,
  INVOICE_NOTES_RECEIVED,
  INVOICE_NOTES_REQUEST,
} from '../constants';
import { requests } from '../../helper/agent';
import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { SubmissionError } from 'redux-form/lib/SubmissionError';
import { parseApiErrors } from '../../helper/apiUtils';

export const invoiceNoteAddRequest = () => ({
  type: INVOICE_NOTE_ADD_REQUEST,
});

export const invoiceNoteAdded = (data) => ({
  type: INVOICE_NOTE_ADDED,
  data,
});

export const invoiceNoteAdd = (data) => {
  return (dispatch) => {
    dispatch(invoiceNoteAddRequest());
    return requests
      .post(`${API_ROUTES.INVOICE_NOTE}`, data)
      .then((response) => dispatch(invoiceNoteAdded(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

export const invoiceNoteDeleteRequest = () => ({
  type: INVOICE_NOTE_DELETE_REQUEST,
});

export const invoiceNoteDeleted = (id) => ({
  type: INVOICE_NOTE_DELETED,
  id,
});

export const invoiceNoteDelete = (invoiceNoteId) => {
  return (dispatch) => {
    dispatch(invoiceNoteDeleteRequest());
    return requests
      .delete(`${API_ROUTES.INVOICE_NOTE}/${invoiceNoteId}`)
      .then(() => dispatch(invoiceNoteDeleted(invoiceNoteId)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

export const invoiceNotesRequest = () => ({
  type: INVOICE_NOTES_REQUEST,
});

export const invoiceNotesReceived = (data, invoiceId) => ({
  type: INVOICE_NOTES_RECEIVED,
  data,
  invoiceId,
});

export const invoiceNotesError = (error) => ({
  type: INVOICE_NOTES_ERROR,
  error,
});

export const invoiceNotesFetch = (invoiceId) => {
  return (dispatch) => {
    dispatch(invoiceNotesRequest());

    return requests
      .get(`${API_ROUTES.INVOICE_NOTES.replace(':id', invoiceId)}`, { pagination: false })
      .then((response) => dispatch(invoiceNotesReceived(response, invoiceId)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(invoiceNotesError(parseApiErrors(error)));
      });
  };
};
